import React, { createContext, useState, useEffect } from 'react';
import axios from 'axios';
import config from '../config/config'

export const OptionsContext = createContext();

export function OptionsProvider(props) {

  const [care, setCare] = useState([])
  const [clinical, setClinical] = useState([])
  const [beds, setBeds] = useState([])
  const [amenities, setAmenities] = useState([])
  const [insurance, setInsurance] = useState([])

  const [tags, setTags] = useState([])


  useEffect(() => {
    getCare()
    getClinical()
    getBeds()
    getAmenities()
    getInsurance()
  }, [])

  const getCare = async () => {
    const response = await axios.get(`${config.apiUrl}/api/options/care`);
    setCare(response.data);
  }

  const updateCare = async (data) => {
  
    let arr = data.filter(e => e[1] !== null && e[1] !== '').map(e => e[1].trim())
    if (arr.length === 0) {
      return
    }

    await axios.post(`${config.apiUrl}/api/options/care/update`, {
      options: arr
    });

    getCare()
  }


  const getClinical = async () => {
    const response = await axios.get(`${config.apiUrl}/api/options/clinical`);
    setClinical(response.data);
  }

  const updateClinical = async (data) => {
    
    let arr = data.filter(e => e[1] !== null && e[1] !== '').map(e => e[1].trim())
    if (arr.length === 0) {
      return
    }

    await axios.post(`${config.apiUrl}/api/options/clinical/update`, {
      options: arr
    });

    getClinical()
  }


  const getBeds = async () => {
    const response = await axios.get(`${config.apiUrl}/api/options/beds`);
    setBeds(response.data);
  }

  const updateBeds = async (data) => {
    let arr = data.filter(e => e[1] !== null && e[1] !== '').map(e => e[1].trim())
    if (arr.length === 0) {
      return
    }

    await axios.post(`${config.apiUrl}/api/options/beds/update`, {
      options: arr
    });

    getBeds()
  }


  const getAmenities = async () => {
    const response = await axios.get(`${config.apiUrl}/api/options/amenities`);
    setAmenities(response.data);
  }

  const updateAmenities = async (data) => {
    let arr = data.filter(e => e[1] !== null && e[1] !== '').map(e => e[1].trim())
    if (arr.length === 0) {
      return
    }

    await axios.post(`${config.apiUrl}/api/options/amenities/update`, {
      options: arr
    });

    getAmenities()
  }


  const getInsurance = async () => {
    const response = await axios.get(`${config.apiUrl}/api/options/insurance`);
    setInsurance(response.data);
  }

  const updateInsurance = async (data) => {
    let arr = data.filter(e => e[1] !== null && e[1] !== '').map(e => e[1].trim())
    if (arr.length === 0) {
      return
    }

    await axios.post(`${config.apiUrl}/api/options/insurance/update`, {
      options: arr
    });

    getInsurance()
  }

  const getTags = async () => {
    const response = await axios.get(`${config.apiUrl}/api/tag`);
    setTags(response.data);
  }

  const editTag = async (id, data) => {
    try {
      await axios.put(`${config.apiUrl}/api/tag/edit/${id}`, data);
      await getTags()
    } catch (err) {
      console.log(err);
      throw err;
    }
  }

  const createTag = async (data) => {
    try {
      await axios.post(`${config.apiUrl}/api/tag/create`, { ...data });
      await getTags()
    } catch (err) {
      console.log(err);
      throw err;
    }
  }

  const deleteTag = async (id) => {
    await axios.put(`${config.apiUrl}/api/tag/delete/${id}`);
    getTags()
  }

  return (
    <OptionsContext.Provider
      value={{
        care,
        updateCare,
        clinical,
        updateClinical,
        beds,
        updateBeds,
        amenities,
        updateAmenities,
        insurance,
        updateInsurance,
        tags,
        getTags,
        editTag,
        createTag,
        deleteTag
      }}
    >
      {props.children}
    </OptionsContext.Provider>
  );
}
